import React from "react";
import "./keyNumberData.css";
import keyNumbersData from "../../../assets/keyNumbersData.json";

export default function KeyNumbersData() {
  const data = keyNumbersData.keyNumbersData;
  return (
    <section className="keyNumbers-section">
      <div className="keyNumbers-content">
        {Object.values(data).map((item) => (
          <div key={item.key} className="keyNumber-value">
            <h2>{item.value}</h2>
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
